import React, { FC, SyntheticEvent } from 'react'

import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { moveToIgnoreCombineAction } from 'actions/contactList/additionalContactListAction'
import { ComplaintsType } from 'api/complaints/complaintsApi'
import { ComplainList } from 'components/block/Complaints/ComplainList'
import { HeaderComponent } from 'components/block/HeaderComponent'
import { Header } from 'components/page/ForeignProfile/ForeignProfile.styled'
import { profileTooltipComplaintId } from 'components/page/UserProfile/constants'
import { ModalBackButton } from 'components/presentational/button/ModalBackButton'
import { ComplaintSvg } from 'components/presentational/svg/ComplaintSvg'
import { RightTopTooltip } from 'components/presentational/Tooltip'
import { push } from 'functions/router'
import { useAuthorizationPath } from 'hooks/useAuthorizationLink'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'
import { useTooltip } from 'hooks/useTooltip'

export const HeaderView: FC<{ userId: number }> = ({ userId }) => {
  const dispatch = useDispatch()

  const [tooltipState, toggleTooltipState] = useTooltip(
    profileTooltipComplaintId
  )
  const authorizationPath = useAuthorizationPath()
  const openAuthorization = () => dispatch(push(authorizationPath))

  const { authorized } = useShallowEqualSelector(
    ({ authorizationReducer: { authorized } }) => ({
      authorized,
    })
  )

  const updateContactListAfterIgnored = () => {
    dispatch(moveToIgnoreCombineAction(userId))
  }

  const handleMenuClick = (event: SyntheticEvent) => {
    event.preventDefault()
    if (authorized) {
      toggleTooltipState(event)
    } else {
      openAuthorization()
    }
  }

  return (
    <Header>
      <HeaderComponent
        goBack={<ModalBackButton />}
        settings={
          <Complaint
            onClick={handleMenuClick}
            data-name="link-complains-action"
            to={authorizationPath}
          >
            <ComplaintSvg />

            {tooltipState && (
              <RightTopTooltip>
                <ComplainList
                  violatorId={userId}
                  complaintListType={ComplaintsType.profile}
                  complaintType={ComplaintsType.profile}
                  entityId={userId}
                  actionAfterComplainSend={updateContactListAfterIgnored}
                />
              </RightTopTooltip>
            )}
          </Complaint>
        }
      />
    </Header>
  )
}

const Complaint = styled(Link)`
  display: flex;
  position: relative;
  cursor: pointer;
  height: 40px;
  width: 40px;
  justify-content: center;
  align-items: center;
`
